import { motion } from "framer-motion";
import { Shield, Wallet, MapPin } from "lucide-react";

const promises = [
  {
    icon: Shield,
    title: "ALL CREDIT",
    subtitle: "SITUATIONS WELCOME",
    description:
      "Bad credit, low credit, no credit, or new to Canada — we work with customers in all types of credit situations and help explore financing options that fit their needs.",
    image: "/images/promise-inspection.jpg",
    // cta: "Apply for Financing",
  },
  {
    icon: Wallet,
    title: "APPROVAL HELP",
    subtitle: "THAT FITS YOUR SITUATION",
    description:
      "If you have a steady income or full-time job, our team will work hard with multiple lenders to help find a financing solution that works for your budget and circumstances.",
    image: "/images/promise-financing.jpg",
    // cta: "Get Pre-Approved",
  },
  {
    icon: MapPin,
    title: "NEW TO CANADA?",
    subtitle: "WE'RE HERE TO HELP",
    description:
      "Starting fresh with no Canadian credit history? We help newcomers and first-time buyers understand their options and move closer to getting behind the wheel of a reliable vehicle.",
    image: "/images/promise-delivery.jpg",
    // cta: "Explore Your Options",
  },
];

/**
 * Promise Section Component
 *
 * Features:
 * - Three promise cards with images and icons
 * - Hover animations on cards
 * - Call-to-action buttons
 */
export default function PromiseSection() {
  return (
    <section className="py-12 md:py-14 lg:py-18 xl:py-20 bg-white w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-4xl md:text-4xl font-bold text-gray-900">
            ALL <span className="text-brand-red">CREDIT WELCOME</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-red to-brand-gold mx-auto mt-4 rounded-full" />
        </motion.div>

        {/* Promise Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {promises.map((promise, index) => (
            <motion.div
              key={promise.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="group"
            >
              <div className="bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-500 h-full flex flex-col">
                {/* Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={promise.image}
                    alt={promise.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-brand-red rounded-xl flex items-center justify-center">
                      <promise.icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-serif text-xl font-bold text-gray-900 mb-1">
                    {promise.title}
                  </h3>
                  <h4 className="font-serif text-lg font-semibold text-brand-red mb-4">
                    {promise.subtitle}
                  </h4>
                  <p className="text-gray-600 leading-relaxed mb-6 flex-1">
                    {promise.description}
                  </p>
                  {/* <button className="inline-flex items-center gap-2 text-brand-red font-semibold hover:gap-3 transition-all duration-300 group/btn">
                    {promise.cta}
                    <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                  </button> */}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
